export default __webpack_public_path__ + "static/media/white-circle.a4248fa6.svg";